import React, { forwardRef } from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import AsyncIcon from '@atlassian/jira-common-components-async-icon/src/view.tsx';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { Minimized } from '@atlassian/jira-minimizable-modal/src/ui/modal-container/minimized/index.tsx';
import { useParseSummaryValue } from '../../../../common/utils/parse-summary-value/index.tsx';
import { useMinimizableModalWrapperProps } from '../../../../controllers/minimizable-modal-wrapper-props/main.tsx';
import type { MinimizableModalMinimizedProps } from './types.tsx';

export const MinimizableModalMinimized = forwardRef<HTMLElement, MinimizableModalMinimizedProps>(
	({ className, summaryValue }: MinimizableModalMinimizedProps, ref) => {
		const { parseSummaryValue } = useParseSummaryValue();
		const { selectedIssueType, projectType } = useMinimizableModalWrapperProps();

		return (
			// @ts-expect-error - TS2322 - Type '((instance: MinimizableModalMinimizedProps | null) => void) | MutableRefObject<MinimizableModalMinimizedProps | null> | null' is not assignable to type '((string | ((instance: Component<ThemedOuterStyledProps<DiffBetween<{ className: any; }, Omit<HTMLElement & RefAttributes<MinimizedContainerProps>, "theme"> & { ...; }>, any>, any, any> | null) => void) | RefObject<...>) & (((instance: MinimizedContainerProps | null) => void) | RefObject<...>)) | null | undefined'.
			<StyledMinimized ref={ref} isItalic={!summaryValue} transitionClass={className}>
				{selectedIssueType?.iconUrl && projectType !== SERVICE_DESK_PROJECT ? (
					<TitleContainer>
						<IconContainer data-testid="issue-create.ui.modal.modal-wrapper.minimizable-modal-minimized.issue-type-icon">
							<AsyncIcon width={16} url={selectedIssueType?.iconUrl} />
						</IconContainer>
						{parseSummaryValue(summaryValue, selectedIssueType?.label)}
					</TitleContainer>
				) : (
					parseSummaryValue(summaryValue, selectedIssueType?.label)
				)}
			</StyledMinimized>
		);
	},
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconContainer = styled2.span({
	marginRight: token('space.200'),
	display: 'inline-flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TitleContainer = styled2.span({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const StyledMinimized = styled(Minimized).attrs({
	// @ts-expect-error - TS2339 - Property 'transitionClass' does not exist on type 'ThemedStyledProps<HTMLElement & RefAttributes<MinimizedContainerProps>, any>'.
	className: (props) => props.transitionClass,
})``;
